import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../components/UI/BackButton';
import { formatData, getUserEmailToName, translate, validateToken } from '../../../utils/util';

const TokenDetail = (props) => {

    return (
        <>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '12px' }}>
                        <form>
                            <div className="row" style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}>
                                <div className="subtitle col s12" style={{ padding: '0px' }}>
                                    <span className="field f-1r">{translate('token.details', 'configuration')}</span>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r" >
                                            {`${translate("token.code", "configuration")}`}: {`${props.token.code || ''}`}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r" style={{ wordWrap: 'break-word' }}>
                                            {`${translate("token.value", "configuration")}`}: {`${props.token.value || ''}`}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r" style={{ wordWrap: 'break-word' }}>
                                            {`Valido até: ${validateToken(props.token.value || '')} `}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <span className="truncate second-text-color" style={{ display: 'block' }}>
                                            <i className="mdi mdi-history" /> {formatData(props.token.updateOn)}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s12"></div>
                                    <span className="second-text-color" style={{ display: 'block' }}>
                                        <i className="mdi mdi-account" /> {getUserEmailToName(props?.usersFromElog, props.token.updateBy)}
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.configReducer.token,
        usersFromElog: state.usersElogReducer.usersElog
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation()(TokenDetail)));